export default "__VITE_ASSET__8e3ff8b6__";